import { render, staticRenderFns } from "./FraudAlert.vue?vue&type=template&id=79f34e3c&scoped=true"
import script from "./FraudAlert.vue?vue&type=script&lang=js"
export * from "./FraudAlert.vue?vue&type=script&lang=js"
import style0 from "./FraudAlert.vue?vue&type=style&index=0&id=79f34e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f34e3c",
  null
  
)

export default component.exports